<script setup>
defineEmits(['update:mois', 'update:annee', 'next', 'prev'])
</script>
<template>
  <v-container>
    <v-row align="center" class="mb-0" no-gutters>
      <v-icon :disabled="disablePrev" left color="primary" @click="previous">{{ preIcon }}</v-icon>
      <span class="pr-2">{{ moisFromate }}</span>
      <span>{{ annee }}</span>
      <v-icon :disabled="disableNext" right color="primary" @click="next">{{ nextIcon }}</v-icon>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 's-year-month-selector',
  props: {
    initMois: {
      type: Number,
      required: true,
    },
    initAnnee: {
      type: Number,
      required: true,
    },
    preIcon: {
      type: String,
      default: 'mdi-chevron-left',
    },
    nextIcon: {
      type: String,
      default: 'mdi-chevron-right',
    },
    disableNext: {
      type: Boolean,
      default: false,
    },
    disablePrev: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    initMois(newVal) {
      this.mois = newVal
    },
    initAnnee(newVal) {
      this.annee = newVal
    },
  },
  computed: {
    ...mapGetters({ getMonthLabel: 'calendrier/getMonthLabel' }),
    moisFromate() {
      return this.getMonthLabel(this.mois)
    },
  },
  data() {
    return {
      mois: undefined,
      annee: undefined,
    }
  },
  methods: {
    previous() {
      if (this.mois > 1) {
        this.mois--
        this.$emit('update:mois', this.mois)
      } else {
        this.mois = 12
        this.$emit('update:mois', this.mois)
        this.annee--
        this.$emit('update:annee', this.annee)
      }
      this.$emit('prev', { mois: this.mois, annee: this.annee })
    },
    next() {
      if (this.mois < 12) {
        this.mois++
        this.$emit('update:mois', this.mois)
      } else {
        this.mois = 1
        this.$emit('update:mois', this.mois)
        this.annee++
        this.$emit('update:annee', this.annee)
      }
      this.$emit('next', { mois: this.mois, annee: this.annee })
    },
    reset() {
      this.mois = this.initMois
      this.annee = this.initAnnee
    },
  },
  created() {
    this.mois = this.initMois
    this.annee = this.initAnnee
  },
}
</script>
